export const DEFAULT_CUSTOM_FILTERS = [
    {
        label: "Schedule",
        regexPattern: "ScheduleName:\\s*([^\\r\\n]*?)(?=\\s+Event:|$)",
        extractionGroup: 1,
    },
];
//# sourceMappingURL=interactionsCardsConstants.js.map